// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__VEA3F","imgEmpty":"index_imgEmpty__qnwwo","img":"index_img__OckkS","tip":"index_tip__76Jle"};